import React, { useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { useEventoContingenciaById } from "../../hooks_cache/useEventoContingencia.js";

import Swal from "sweetalert2";

import StatusBadge from "../../components/StatusBadge";

import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import api from "../../config/axiosConfig.js";

import { useUpdateComprobante } from "../../hooks_cache/useComprobantes.js";
import { AppSettings } from "./../../config/app-settings.js";

const TransmitirDTE = ({ id_comprobante }) => {
  const { empresaSeleccionada } = useSelector((state) => state.auth);
  const id_empresa = empresaSeleccionada?.id; // ✅ Obtener `id_empresa` del estado global
  const updateComprobanteCache = useUpdateComprobante();

  const mutation = useMutation({
    mutationFn: async () => {
      const res = await api.post(`/dte/contingencia/procesarDte/${id_comprobante}`, { id_empresa });
      return res.data;
    },
    onSuccess: (data) => {
      const { mh_response, comprobante } = data;
      updateComprobanteCache(comprobante);
      toast.success(
        <div>
          <h5>Comprobante: {mh_response?.codigoGeneracion}</h5>
          <strong>TRANSMITIDO EXITOSAMENTE</strong>
          {mh_response?.observaciones.length > 0 && (
            <ul style={{ marginTop: "0.5rem" }}>
              {mh_response?.observaciones.map((obs, i) => (
                <li key={i}>{obs}</li>
              ))}
            </ul>
          )}
        </div>
      );
    },
    onError: (err) => {
      const { error } = err;
      toast.error(
        <div>
          <h5>Comprobante: {error?.codigoGeneracion}</h5>
          <strong>{error?.descripcionMsg}</strong>
          {error?.observaciones.length > 0 && (
            <ul style={{ marginTop: "0.5rem" }}>
              {error?.observaciones.map((obs, i) => (
                <li key={i}>{obs}</li>
              ))}
            </ul>
          )}
        </div>
      );
    },
  });

  return (
    <button className="btn btn-success btn-xs" onClick={() => mutation.mutate()} disabled={mutation.isPending || mutation.isSuccess}>
      {mutation.isPending ? "Enviando..." : mutation.isSuccess ? "✅ Transmitido!" : "Transmitir"}
    </button>
  );
};

const ContingenciaInfo = () => {
  const context = useContext(AppSettings);

  const { evento_contingencia_id } = useParams();
  const { data: eventoContingencia = {}, refetch, isFetching } = useEventoContingenciaById(evento_contingencia_id);
  const evento_activo = eventoContingencia?.estado === "abierto" ? true : false;

  useEffect(() => {
    if (isFetching) {
      Swal.fire({
        title: "Cargando evento de contingencia...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  }, [isFetching]);

  useEffect(() => {
    context.handleSetAppContentClass("bg-component");
    return () => {
      context.handleSetAppContentClass("");
    };
  }, []);

  return (
    <div>
      <div className="row mb-md-4">
        <div className="col-md-5 col-12">
          <label className="form-label">Codigo de Generacion:</label>
          <input
            disabled
            type="text"
            className="form-control fs-15px"
            placeholder="Codigo de generacion"
            name="codigoGeneracion"
            value={eventoContingencia.codigoGeneracion || ""}
          />
        </div>

        <div className="col-12 col-md-2 mb-2">
          <label className="form-label">Fecha inicio:</label>
          <input
            disabled
            type="date"
            className="form-control fs-15px"
            placeholder="Fecha de inicio"
            name="fInicio"
            value={eventoContingencia.fInicio || ""}
          />
        </div>

        <div className="col-12 col-md-2 mb-2">
          <label className="form-label">Fecha Fin:</label>
          <input
            disabled
            type="date"
            className="form-control fs-15px"
            placeholder="Fecha de finalizacion"
            name="fFin"
            value={eventoContingencia.fFin || ""}
          />
        </div>

        <div className="col-12 col-md-3 mb-2 mt-3">
          <div className=" text-center">
            <StatusBadge estado={eventoContingencia?.estado || ""} />
          </div>
        </div>

        <div className="col-12 col-md-7 mb-2">
          <label className="d-flex align-items-center fs-13px">Motivo de la contingencia:</label>
          <textarea
            disabled
            className="form-control fs-15px"
            placeholder="Motivo de la contingencia"
            name="motivoContingencia"
            value={eventoContingencia.motivoContingencia || ""}
          />
        </div>

        <hr />

        <div className="">
          <div className="shadow table-responsive">
            <table className="table table-thead-sticky table-tfoot-sticky table-tbody-bordered table-px-10px table-py-4px table-sm table-striped text-nowrap mb-0">
              <thead>
                <tr className="text-nowrap">
                  <th>#</th>
                  <th>COMPROBANTE</th>
                  <th>TIPO COMPROBANTE</th>
                  <th>FECHA</th>
                  <th>HORA</th>
                  <th>SELLO RECIBIDO</th>
                  <th width="10%">ACCIONES</th>
                </tr>
              </thead>
              <tbody>
                {eventoContingencia?.DetalleEventoContingencia?.map((dte, index) => {
                  const { Comprobante: comprobante, id_comprobante: id, noItem, codigoGeneracion } = dte;

                  return (
                    <tr key={id}>
                      <td>{noItem}</td>
                      <td>
                        <Link to={`/venta/comprobante/${id}`}>{codigoGeneracion}</Link>
                      </td>
                      <td>{comprobante.TipoDTE?.descripcion?.toUpperCase()}</td>
                      <td>{comprobante.fecEmi}</td>
                      <td>{comprobante.horEmi}</td>
                      <td>
                        {comprobante.selloRecibido ? (
                          <span className="badge bg-success">TRANSMITIDO</span>
                        ) : (
                          <span className="badge bg-danger">NO TRANSMITIDO</span>
                        )}
                      </td>

                      <td>
                        {evento_activo ? "Contingencia Activo" : !comprobante.selloRecibido && <TransmitirDTE id_comprobante={id} />}{" "}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContingenciaInfo;
